import classNames from 'classnames'
import React from 'react'

const Loader: React.FunctionComponent<LoaderProps> = props => {
  const overlayClasses = classNames(
    'Modal__overlay',
    props.local ? 'Modal__overlay--local' : null,
    'Modal__overlay--solid',
    props.visible ? null : 'Modal__overlay--hidden',
    props.overlayClassName ? props.overlayClassName : null,
  )
  const containerClasses = classNames(
    'Loader__container',
    'l-centered-child',
    props.className,
  )
  const holderClasses = classNames(
    'Loader__holder',
    props.sticky && 'Loader__holder--sticky',
  )
  const loaderClasses = classNames('Loader', props.large && 'Loader--large')
  return (
    <div
      style={
        props.transparent ? { backgroundColor: 'rgba(244, 244, 244, 0.5)' } : {}
      }
      className={overlayClasses}
    >
      <div className={containerClasses}>
        <div className={holderClasses}>
          <div className={loaderClasses} />
        </div>
      </div>
    </div>
  )
}
Loader.defaultProps = {
  visible: false,
  large: true,
  sticky: false,
  transparent: false,
}

type LoaderProps = {
  visible?: boolean
  local?: boolean
  large?: boolean
  sticky?: boolean
  className?: string
  overlayClassName?: string
  transparent?: boolean
}

export default Loader
